import { Component } from '@angular/core';

@Component({
    selector: 'app-freeway-layout-footer-social-twitter',
    templateUrl: './freeway-layout-footer-social-twitter.component.html',
    standalone: false
})
export class FreewayLayoutFooterSocialTwitterComponent {}
